import { createTheme } from "@mui/material/styles";

// mode: "light" | "dark"
// customColors: { sidebar, header, activeButton }
export const getDesignTokens = (mode, customColors = {}) => ({
  palette: {
    mode,
    ...(mode === "light"
      ? {
          primary: {
            main: (customColors && customColors.activeButton) || "#1976d2",
          },
          background: {
            textwhite: "#fff",
            default: "#fff",
            paper: "#ffffff",
            bgwhite: "#fff",
            schoolBgHead:'#fafafa',
            maincontentBg: "#F5F5F6",
            bggrey: "#F7FAFC",
            bggreenlight: "#e6f9ec",
            bggreen: "#0ebb13",
            bgskyblue: "#E3F2FD",
            bgorangelight: "#ffe0b2",
            bgorangedark: "#e65100",
            bgred: "#dc3545",
            bgredlight: "#ffe5e5",
            bgblue: "#0d47a1",
            bgbluelight: "#bbdefb",
            bgpurple: "#8f01ff",
            bgpurplelight: "#c2a6d7",
            text: "rgb(82 82 108 / 80%)",
            textblack: "#000",
            sidebarbg: (customColors && customColors.sidebar) || "#fff!important",
            bgactivemenu: "#8f01ff",
            Tableheadbg: "#f2f4f8",
            toggleIconColor: "#444444",
            bgmodalheader: "#f2f4f8",
            disabledbg: "#e0e0e0",
            bgyellowColor: "#fff6e0",
            matrixPresent: "#35e034",
            matrixAbsent: "#F45B31",
            matrixLeave: "#a1dcf4",
            matrixWeekend: "#DDE3E9",
            matrixHoliday: "#687FE5",
            matrixNoData: "#F1F1F1",
            matrixLate: "#ffcc80",
            eventCardbg: "#E0F2F1",
            noticeCardbg: "#E3F2FD",
            alertCardbg: "#FFEBEE",
            rolebgheader: "linear-gradient(135deg, #673ab7, #9575cd)",
            studentDashbg: "linear-gradient(135deg, #f3e5ff, #d9b3ff)",
            teacherDashbg: "linear-gradient(135deg, #ffe0b2, #ffb74d)",
            staffDashbg: "linear-gradient(135deg, #bbdefb, #64b5f6)",
            classDashbg: "linear-gradient(135deg, #c8e6c9, #81c784)",
            classDashbgred: "linear-gradient(135deg, #f4b6b6, #ec5a5a)",
            studentDashIcon: "#8e24aa",
            teacherDashIcon: "#e65100",
            staffDashIcon: "#0d47a1",
            classDashIcon: "#1b5e20",
            calenderDash: "#F45B31",
            feeChartbg: "#d9b3ff",
            mintGreenbg: "#E8F5E9",
            creamyOrangebg: "#FFF3E0",
            lavenderbg: "#F3E5F5",
            noticebg1: "#FFF4D1",
            noticebg2: "#ECECFF",
            noticeIconbg1: "#F8B400",
            noticeIconbg2: "#7B74EC",
            eventbg1: "#D1F2EB",
            eventbg2: "#FDEBD0",
            chipbg: "#fff",
            holidaybg: "#687FE5",
            saturdaybg: "#77d077",
            liteVioletbg: "#e0bbf5",
            cardVioletbg: "#9281ff",
            greybg: "#f5f5f5",
            lightskybg: "#e4e8ff",
            matrixHalfday: "#fbc02d",
            allBlackbg: "#000",
            allWhitebg: "#fff",
            formchipbg: "#0000000f",
            checkboxbg: "#63737a",
            cardtext:'#e7e7e8',
            bgSky:'#E9F0FF',
            softSkyBlue:'#9EC9FF',
            pastelEmerald:'#8FE3B0',
            softYellow:'#f7e465',
            pastelCoral:'#FF9E9E',

          },
          custom: {
            greytextColor: "#98a3ab",
            yellowtext: "#f0ad4e",
            skybluetext: "#49a8ee",
            whitetext: "#fff",
            purpletextColor: "#a442f3",
            orangetextcolor: "#e9d3c8ff",
            bluetextcolor: "#0d47a1",
            redtextcolor: "#dc3545",
            greentextcolor: "#28a745",
            borderColor: "#E9EDF4 !important",
            borderBlackColor: "#e0e0e0 !important",
            InputborderColor: "#673ab7!important",
            BulkInputborderColor: "#bdbdbd!important",
            CustominputborderColor:"#673ab7!important",
            hoverBackground: "#f5f5f5",
            menuBackground: "#ffffff",
            menuText: "rgb(82 82 108 / 80%)",
            submenuBackground: "#f9f9f9",
            submenuText: "#444444",
            MenuIconColor: "#6b7280",
            listMenuhoverbg: "rgba(0, 0, 0, 0.04)",
            colorActive: "#8f01ff",
            tableHeadingText: "#212529",
            TableheadText: "#1b2124",
            eventIcon: "#AB47BC",
            alertIcon: "#E53935",
            noticeIcon: "#1E88E5",
            studentPresent: "#d9b3ff",
            teacherPresent: "#ffb74d",
            staffPresent: "#64b5f6",
            chartAbsent: "#FF746C",
            chartLeave: "#FFD54F",
            dividerBorder: "rgba(0, 0, 0, 0.12)",
            header: (customColors && customColors.header) || "#fff",
          },
        }
      : {
          primary: {
            main: (customColors && customColors.activeButton) || "#90caf9",
          },
          background: {
            textwhite: "#fff",
            default: "#121212",
            paper: "#06080a",
            bgwhite: "#06080a",
            schoolBgHead:"#111417",
            maincontentBg: "#06080a",
            bggreen: "#81c784",
            bgred: "#e5252a",
            bgblue: "#116AEF",
            bgpurple: "#8f01ff",
            bgpurplelight: "#c2a6d7",
            text: "#ffffff",
            textblack: "#fff",
            sidebarbg: (customColors && customColors.sidebar) || "#111417!important",
            bgactivemenu: "rgba(115,102,255,.2)",
            Tableheadbg: "#1e2933",
            VoiletMainbgColor: "#a442f3",
            rolebgheader: "linear-gradient(135deg, #673ab7, #9575cd)",
            VoiletMainbgColorText:
              "linear-gradient(90deg, #9B28F1 0%, #7B17E4 100%)",
            toggleIconColor: "#444444",
            matrixPresent: "#35e034",
            matrixAbsent: "#F45B31",
            matrixLeave: "#a1dcf4",
            matrixWeekend: "#495057",
            matrixHoliday: "#687FE5",
            matrixNoData: "#1C1C1C",
            matrixLate: "#f0a500",
            boxShadow:
              "inset 1.5px 1.5px 0px rgba(255, 255, 255, .25), inset -1.5px -1.5px 0px rgba(0, 0, 0, .1)",
            bgmodalheader: "#1e2933",
            disabledbg: "#2f2f2f",
            cardVioletbg: "#9281ff",
            liteVioletbg: "#a275d4",
            eventCardbg: "#1e3b38",
            noticeCardbg: "#1a2f45",
            alertCardbg: "#3d1e1e",
            studentDashbg: "linear-gradient(135deg, #f3e5ff, #d9b3ff)",
            teacherDashbg: "linear-gradient(135deg, #ffe0b2, #ffb74d)",
            staffDashbg: "linear-gradient(135deg, #bbdefb, #64b5f6)",
            classDashbg: "linear-gradient(135deg, #c8e6c9, #81c784)",
            classDashbgred: "linear-gradient(135deg, #f4b6b6, #ec5a5a)",
            studentDashIcon: "#8e24aa",
            teacherDashIcon: "#e65100",
            staffDashIcon: "#0d47a1",
            classDashIcon: "#1b5e20",
            calenderDash: "#D3471F",
            feeChartbg: "#d9b3ff",
            bggreenlight: "#1e3d2f",
            bgyellowColor: "#4a3f1a",
            bgredlight: "#4a1a1a",
            bgskyblue: "#1e2a38",
            mintGreenbg: "#1b2c22",
            creamyOrangebg: "#3b2f1a",
            lavenderbg: "#2e1f3c",
            bggrey: "#212121",
            noticebg1: "#4A3F1A",
            noticebg2: "#2E2E50",
            noticeIconbg1: "#B8860B",
            noticeIconbg2: "#5C59B2",
            eventbg1: "#1C3A36",
            eventbg2: "#3A2F1C",
            chipbg: "#fff",
            holidaybg: "#4C61B8",
            saturdaybg: "#4CAF50",
            greybg: "#1E1E1E",
            bgorangedark: "#e65100",
            bgorangelight: "#ffe0b2",
            bgbluelight: "#bbdefb",
            lightskybg: "#e4e8ff",
            matrixHalfday: "#fbc02d",
            allBlackbg: "#000",
            allWhitebg: "#fff",
            formchipbg: "#252445",
            graydarkcolor: "#9e9e9e",
            checkboxbg: "#63737a",
            cardtext:'#111417',
            bgSky:'#2e2c2c',
            softSkyBlue:'#2d496b',
            pastelEmerald:'#275539',
            softYellow:'#59511f',
            pastelCoral:'#451515',
          },
          custom: {
            borderBlackColor: "#585858 !important",
            borderColor: "#262d30 !important",
            InputborderColor: "#12303d!important",
            CustominputborderColor: "#31505e!important",
            hoverBackground: "#262D30",
            menuBackground: "#1e1e1e",
            menuText: "#EBF2F5",
            submenuBackground: "#2c2c2c",
            submenuText: "#dddddd",
            MenuIconColor: "#EBF2F5",
            listMenuhoverbg: "rgba(255, 255, 255, 0.08)",
            colorActive: "#a442f3",
            tableHeadingText: "#EBF2F5",
            TableheadText: "#EBF2F5",
            eventIcon: "#AB47BC",
            alertIcon: "#E53935",
            noticeIcon: "#1E88E5",
            studentPresent: "#d9b3ff",
            teacherPresent: "#ffb74d",
            staffPresent: "#64b5f6",
            chartAbsent: "#FF746C",
            feeChartStroke: "#e0e0e0",
            feeChartFill: "#666",
            redtextcolor: "#dc3545",
            greentextcolor: "#28a745",
            yellowtext: "#f0ad4e",
            greytextColor: "#98a3ab",
            bluetextcolor: "#0d47a1",
            whitetext: "#fff",
            dividerBorder: "rgba(255, 255, 255, 0.12)",
            purpletextColor: "#a442f3",
            header: (customColors && customColors.header) || "#111417",
          },
        }),
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor:
            (customColors && customColors.header) ||
            (mode === "light" ? "#fff" : "#111417"),
        },
      },
    },
  },
});

export const buildTheme = (mode, customColors) =>
  createTheme(getDesignTokens(mode, customColors));
